import { Compass, Droplets, SunMedium, Wind } from "lucide-react"

import { formatCourseDate } from "@/lib/date"

export function CoursePlot({
  course,
  location,
  date,
}: {
  course: string
  location: string
  date: string
}) {
  return (
    <section className="course-plot" aria-labelledby="course-plot-title">
      <div className="course-plot__canvas">
        <div className="course-plot__heading">
          <div>
            <span className="plot-label">Course routing · synthetic</span>
            <h2 id="course-plot-title">{course}</h2>
            <p>{location}</p>
          </div>
          <span className="course-plot__north">
            <Compass aria-hidden="true" />
            North
          </span>
        </div>

        <svg
          className="course-plot__graphic"
          viewBox="0 0 760 260"
          role="img"
          aria-label={`Abstract routing diagram for ${course}`}
        >
          <g className="course-plot__contours" aria-hidden="true">
            <path d="M-30 58C92 4 190 86 310 42s214-38 330 4 132 14 170-8" />
            <path d="M-24 92C84 38 176 111 301 75s222-48 344 4 120 24 162-12" />
            <path d="M-18 130c104-50 196 15 305-14s220-46 338 2 126 28 178-4" />
            <path d="M-10 171c120-48 211 6 321-22s198-23 302 8 129 25 194-6" />
            <path d="M18 220c116-39 190 4 294-20s206-18 300 7 120 20 169-4" />
            <path d="M76 12c24 34 9 68-24 84s-39 54-12 87 72 44 83 77" />
            <path d="M667-8c-30 41-13 75 24 99s42 63 11 95-49 48-36 82" />
          </g>

          <path
            className="course-plot__route-shadow"
            d="M78 198C134 190 139 136 205 140s91-77 153-61 91 91 157 70 62-72 142-85"
            aria-hidden="true"
          />
          <path
            className="course-plot__route"
            d="M78 198C134 190 139 136 205 140s91-77 153-61 91 91 157 70 62-72 142-85"
            aria-hidden="true"
          />

          {[
            { x: 78, y: 198, label: "1" },
            { x: 205, y: 140, label: "3" },
            { x: 358, y: 79, label: "5" },
            { x: 515, y: 149, label: "7" },
            { x: 657, y: 64, label: "9" },
          ].map((node) => (
            <g
              className="course-plot__node"
              key={node.label}
              transform={`translate(${node.x} ${node.y})`}
              aria-hidden="true"
            >
              <circle r="15" />
              <text y="5" textAnchor="middle">
                {node.label}
              </text>
            </g>
          ))}

          <g className="course-plot__clubhouse" aria-hidden="true">
            <rect x="42" y="221" width="13" height="13" rx="2" />
            <text x="65" y="232">
              CLUBHOUSE
            </text>
          </g>
        </svg>

        <span className="course-plot__coordinate course-plot__coordinate--top">
          N 14° 49′
        </span>
        <span className="course-plot__coordinate course-plot__coordinate--side">
          E 120° 51′
        </span>
      </div>

      <aside className="course-plot__conditions" aria-label="Demo conditions">
        <div className="course-plot__conditions-head">
          <span className="plot-label">Demo conditions</span>
          <strong>{formatCourseDate(date, { weekday: "short" })}</strong>
        </div>
        <dl>
          <div>
            <dt>
              <Wind aria-hidden="true" />
              Wind
            </dt>
            <dd>NE · 7 km/h</dd>
          </div>
          <div>
            <dt>
              <SunMedium aria-hidden="true" />
              Daylight
            </dt>
            <dd>06:04—18:36</dd>
          </div>
          <div>
            <dt>
              <Droplets aria-hidden="true" />
              Surface
            </dt>
            <dd>Firm · normal play</dd>
          </div>
        </dl>
        <p>
          Visual conditions are synthetic and provided to demonstrate course
          context.
        </p>
      </aside>
    </section>
  )
}
